import { render, staticRenderFns } from "./BuildingUserList.vue?vue&type=template&id=7a4ab8ff&scoped=true"
import script from "./BuildingUserList.vue?vue&type=script&lang=js"
export * from "./BuildingUserList.vue?vue&type=script&lang=js"
import style0 from "./BuildingUserList.vue?vue&type=style&index=0&id=7a4ab8ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4ab8ff",
  null
  
)

export default component.exports